export const MARKER_EVENTS = {
  ADD_ACTIVE: 'add_active',
  REMOVE_ACTIVE: 'remove_active',
  DOCUMENT_ADD_ACTIVE: 'document_add_active',
  DOCUMENT_REMOVE_ACTIVE: 'remove_add_active'
};
